<template>
    <div class="formulario-empresa">
        <!--<span v-if="company.length <= 0" >Carregando...</span>-->

        <div class="row">
            <div class="col m5 s12 l12" v-if="true">
                <h5><strong>Principais Informações da Empresa</strong></h5>
            </div>
        </div>
        <div class="row">
            <div class="input-field col m6 s12">
                <input
                    id="empresa_razao_social"
                    type="text"
                    v-model="formData.empresa_razao_social"
                />
                <label
                    for="empresa_razao_social"
                    :class="checkValue(formData.empresa_razao_social)"
                    v-if="formData.empresa_tipo_id == '2'"
                >
                    Razão social
                </label>
                <label
                    for="empresa_razao_social"
                    :class="checkValue(formData.empresa_razao_social)"
                    v-if="formData.empresa_tipo_id != '2'"
                >
                    Razão social
                </label>
            </div>

            <div class="input-field col m6 s12">
                <input
                    id="empresa_nome_fantasia"
                    type="text"
                    v-model="formData.empresa_nome_fantasia"
                />
                <label
                    for="empresa_nome_fantasia"
                    :class="checkValue(formData.empresa_nome_fantasia)"
                    >Nome fantasia</label
                >
            </div>

            <div class="input-field col m5 s12">
                <the-mask
                    type="text"
                    id="empresa_cnpj"
                    v-model="formData.empresa_cnpj"
                    :mask="['##.###.###/####-##']"
                />
                <label
                    for="empresa_cnpj"
                    :class="checkValue(formData.empresa_cnpj)"
                    >CNPJ</label
                >
            </div>
            <div class="col m5 s12" v-if="true">
                <label for="status_corretor" class="active">Status</label>
                <!-- <input type="text" v-model="formData.status_corretor" placeholder="Status" id="status_corretor">-->
                <select
                    id="status_corretor"
                    class="browser-default"
                    v-model="formData.status_corretor"
                >
                    <option value="" disabled selected>Selecione um Status</option>
                    <option value="ativo">Ativo</option>
                    <option value="ativo sem susep">Ativo sem Susep</option>
                    <option value="desvinculado">Desvinculado</option>
                    <option value="inativo">Inativo</option>
                    <option value="em processo de cadastro">Em processo de Cadastro</option
                    >
                </select>
            </div>

            <div class="col m2 s12" v-if="true">
                <label for="status_id" class="active">Id</label>
                <input
                    id="status_id"
                    :value="formData.empresa_id"
                    :readonly="true"
                    class="browser-default"
                />
            </div>
            <div class="col m2 s12 l12 ">
                <label for="parent_id" class="typo__label"
                    >Superior Imediato:</label
                >
                <multiselect
                    v-model="formData.parent"
                    :options="company"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="false"
                    placeholder="Selecione o superior imediato"
                    label="empresa_nome_fantasia"
                    track-by="empresa_id"
                    @input="onChange($event)"
                    @search-change="onSearchChange"
                />
            </div>

            <div class="col m3 s12" v-if="false">
                <label for="empresa_tipo_id">Tipo</label>

                <select
                    class="browser-default"
                    v-model="formData.empresa_tipo_id"
                    id="empresa_tipo_id"
                >
                    <option value="" disabled selected
                        >Selecione um tipo</option
                    >
                    <option value="1">{{ lang.corretora }}</option>
                    <option value="2">{{ lang.parceira }}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="input-field col m6 s12">
                <input
                    id="email_cobranca"
                    type="text"
                    v-model="formData.email_cobranca"
                />
                <label
                    for="email_cobranca"
                    :class="checkValue(formData.email_cobranca)"
                    >E-mail Cobrança</label
                >
            </div>
            <div class="input-field col m6 s12">
                <input
                    id="email_sinistro"
                    type="text"
                    v-model="formData.email_sinistro"
                />
                <label
                    for="email_sinistro"
                    :class="checkValue(formData.email_sinistro)"
                    >E-mail Sinistro</label
                >
            </div>
        </div>
        <div class="row">
            <div class="input-field col m6 s12">
                <input
                    id="inscricao_municipal"
                    type="text"
                    v-model="formData.inscricao_municipal"
                />
                <label
                    for="inscricao_municipal"
                    :class="checkValue(formData.inscricao_municipal)"
                    >Inscrição Municipal</label
                >
            </div>
            <!-- <div class="input-field col m6 s12">
                <input
                    id="inscricao_estadual"
                    type="text"
                    v-model="formData.inscricao_estadual"
                />
                <label
                    for="inscricao_estadual"
                    :class="checkValue(formData.inscricao_estadual)"
                    >Inscrição Estadual</label
                >
            </div> -->
        </div>
        <div class="row">
            <div class="input-field col m6 s12">
                <input
                    id="atividade"
                    type="text"
                    v-model="formData.atividade"
                />
                <label for="atividade" :class="checkValue(formData.atividade)"
                    >Atividade</label
                >
            </div>
            <div class="input-field col m6 s12">
                <input id="cademp" type="text" v-model="formData.cademp" />
                <label for="cademp" :class="checkValue(formData.cademp)"
                    >Cademp</label
                >
            </div>
        </div>
        <div class="row">
            <div class="input-field col s12 m6">
                <input id="pis" type="text" v-model="formData.pis" />
                <label for="pis" :class="checkValue(formData.pis)">PIS</label>
            </div>
            <!-- <div class="input-field col s12 m6">
                <input
                    id="organizacao"
                    type="text"
                    v-model="formData.organizacao"
                />
                <label
                    for="organizacao"
                    :class="checkValue(formData.organizacao)"
                    >Organização</label
                >
            </div> -->
        </div>
        <div class="row">
            <div class="input-field col m6 s12">
                <input
                    id="data_constituicao"
                    type="date"
                    v-model="formData.data_constituicao"
                />
                <label
                    for="data_constituicao"
                    :class="checkValue(formData.data_constituicao)"
                    >Data Constituição</label
                >
            </div>
            <div class="input-field col m6 s12">
                <input
                    id="data_abertura"
                    type="date"
                    v-model="formData.data_abertura"
                />
                <label
                    for="data_abertura"
                    :class="checkValue(formData.data_abertura)"
                    >Data Abertura</label
                >
            </div>
            <!-- <div class="input-field col m6 s12">
                <input
                    id="data_criacao"
                    type="date"
                    v-model="formData.data_criacao"
                />
                <label
                    for="data_criacao"
                    :class="checkValue(formData.data_criacao)"
                    >Data Criação</label
                >
            </div> -->
        </div>
        <div class="row">
            <div class="col m6 s12 mt-1" v-if="formData.empresa_tipo_id == 2">
                <div>
                    <input
                        type="checkbox"
                        id="pode_indicar"
                        v-model="formData.pode_indicar"
                        value="1"
                    />
                    <label for="pode_indicar"
                        >Os gerentes dessa empresa podem indicar leads para
                        funcionários
                        {{
                            corretoras.length == 1
                                ? "da empresa"
                                : "das empresas"
                        }}
                        {{
                            corretoras
                                .map(e => e.empresa_nome_fantasia)
                                .join(" ou ")
                        }}
                        ?</label
                    >

                    <div class="mt-2" id="alerta-indicacao">
                        <i class="material-icons mr-2 blue-text">info</i>
                        <span
                            >Para que o funcionario seja indicado, você deve ir
                            no perfil do mesmo e habilitar as empresas parceiras
                            que ele pode comercializar</span
                        >
                    </div>
                </div>
            </div>
            <div class="col m6 s12 mt-1">
                <div>
                    <input
                        type="checkbox"
                        id="envia_email"
                        v-model="formData.envia_email"
                        value="1"
                        checked
                    />
                    <label for="envia_email"
                        >Envia e-mail de boas vindas ?</label
                    >
                </div>
            </div>
            <div class="input-field col m12 s12">
                <input
                    id="empresa_nome_fantasia"
                    type="date"
                    v-model="formData.data_ativacao"
                />
                <label
                    for="empresa_nome_fantasia"
                    :class="checkValue(formData.data_ativacao)"
                    >Data de Ativação na Plataforma</label
                >
            </div>

            <div class="input-field col m12 s12">
                <textarea
                    id="observacao_geral"
                    v-model="formData.observacao_geral"
                    rows="120"
                    cols="50"
                    class="mt-1 mb-1"
                    placeholder="Digite as observaçoes necessárias"
                ></textarea>
                <label
                    for="observacao_geral"
                    :class="checkValue(formData.observacao_geral)"
                    >Observações Gerais</label
                >
            </div>
        </div>

        <vsa-list>
            <vsa-item>
                <vsa-heading>
                    Endereço e Informações de Contato
                </vsa-heading>

                <vsa-icon>
                    <vsa-custom-icon />
                </vsa-icon>

                <vsa-content>
                    <div class="flex-row">
                                                        <!-- <div class="col-xs-12 col-md-3">
                                                            <label>Facebook</label>
                                                            <input
                                                                type="text"
                                                                v-model="formData.facebook"
                                                                placeholder="/minhapagina"
                                                            />
                                                        </div>
                                                        <div class="col-xs-12 col-md-3">
                                                            <label>Linkedin</label>
                                                            <input type="text" v-model="formData.linkedin" />
                                                        </div>
                                                        <div class="col-xs-12 col-md-3">
                                                            <label
                                                                >Instagram <i class="fa fa-instagram"></i
                                                            ></label>
                                                            <input
                                                                type="text"
                                                                v-model="formData.instagram"
                                                                placeholder="/minhapagina"
                                                            />
                                                        </div> -->
                        <div class="col-xs-12 col-md-3">
                            <label>Telefone</label>
                            <the-mask
                                v-model="formData.telefone"
                                :mask="['(##) #####-####', '(##) ####-####']"
                            />
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <label>SITE</label>
                            <input
                                type="url"
                                placeholder="https://exemplo.com.br"
                                v-model="formData.site"
                            />
                        </div>

                        <div class="col-xs-12 col-md-3">
                            <label>E-mail</label>
                            <input
                                type="text"
                                placeholder="email@email.com"
                                v-model="formData.email"
                            />
                        </div>

                        <div class="col-xs-12 col-md-6">
                            <label>Plataforma</label>
                            <input
                                type="text"
                                placeholder="Plataforma Origem"
                                v-model="formData.plataforma"
                            />
                        </div>
                        <div class="col-xs-12 col-md-4">
                            <label>CEP</label>
                            <the-mask
                                id="cep"
                                type="text"
                                v-model="formData.cep"
                                :mask="['#####-###']"
                            />
                        </div>
                        <div class="col-xs-12 col-md-4">
                            <label>Endereço</label>
                            <input
                                id="endereco"
                                type="text"
                                v-model="formData.endereco"
                            />
                        </div>
                        <div class="col-xs-12 col-md-4">
                            <label>Número</label>
                            <input type="text" v-model="formData.numero" />
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <label>Complemento</label>
                            <input type="text" v-model="formData.complemento" />
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <label>Bairro</label>
                            <input
                                id="bairro"
                                type="text"
                                v-model="formData.bairro"
                            />
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <label>Cidade</label>
                            <input
                                id="cidade"
                                type="text"
                                v-model="formData.cidade"
                            />
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <!--<label>UF</label>
                            <input type="text" v-model="formData.uf">-->
                            <label for="estado">Estado</label>
                            <select
                                id="estado"
                                v-model="formData.uf"
                                class="browser-default "
                            >
                                <option
                                    value=""
                                    aria-selected="selected"
                                    disabled
                                    >Selecione ...</option
                                >
                                <option value="AC">Acre</option>
                                <option value="AL">Alagoas</option>
                                <option value="AP">Amapá</option>
                                <option value="AM">Amazonas</option>
                                <option value="BA">Bahia</option>
                                <option value="CE">Ceará</option>
                                <option value="DF">Distrito Federal</option>
                                <option value="ES">Espírito Santo</option>
                                <option value="GO">Goiás</option>
                                <option value="MA">Maranhão</option>
                                <option value="MT">Mato Grosso</option>
                                <option value="MS">Mato Grosso do Sul</option>
                                <option value="MG">Minas Gerais</option>
                                <option value="PA">Pará</option>
                                <option value="PB">Paraíba</option>
                                <option value="PR">Paraná</option>
                                <option value="PE">Pernambuco</option>
                                <option value="PI">Piauí</option>
                                <option value="RJ">Rio de Janeiro</option>
                                <option value="RN">Rio Grande do Norte</option>
                                <option value="RS">Rio Grande do Sul</option>
                                <option value="RO">Rondônia</option>
                                <option value="RR">Roraima</option>
                                <option value="SC">Santa Catarina</option>
                                <option value="SP">São Paulo</option>
                                <option value="SE">Sergipe</option>
                                <option value="TO">Tocantins</option>
                            </select>
                        </div>
                    </div>
                </vsa-content>
            </vsa-item>

            <vsa-item>
                <vsa-heading>
                    Responsável
                </vsa-heading>

                <vsa-icon>
                    <vsa-custom-icon />
                </vsa-icon>

                <vsa-content>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-3">
                            <label>Responsável</label>
                            <input
                                type="text"
                                v-model="formData.responsavel"
                                placeholder="Responsável"
                            />
                        </div>
                        <!-- <div class="col-xs-12 col-md-2">
                            <label>CNPJ do Responsável</label>
                            <input type="text" v-model="formData.resp_cnpj" placeholder="CNPJ do Responsável">
                        </div> -->
                        <div class="col-xs-12 col-md-3">
                            <label>CPF do Responsável</label>
                            <the-mask
                                type="text"
                                v-model="formData.resp_cpf"
                                placeholder="CPF do Responsável"
                                :mask="['###.###.###-##']"
                            />
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <label>Susep PJ</label>
                            <input
                                type="text"
                                v-model="formData.nome_susep"
                                placeholder="Número Susep"
                            />
                        </div>
                        <!-- <div class="col-xs-12 col-md-3">
                            <label>CPF Susep</label>
                            <the-mask
                                type="text"
                                v-model="formData.cpf_susep"
                                placeholder="CPF Susep"
                                :mask="['###.###.###-##']"
                            />
                        </div> -->
                    </div>
                    <!-- <div class="flex-row">
                        <div class="col-xs-12 col-md-12">
                            <label>Tipo Representante</label>
                            <input type="text" v-model="formData.tipo_representante" placeholder="Tipo Representante">
                        </div>
                    </div> -->
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-6">
                            <label>Nacionalidade</label>
                            <input
                                type="text"
                                v-model="formData.nacionalidade"
                                placeholder="Nacionalidade"
                            />
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <label>Profissão</label>
                            <input
                                type="text"
                                v-model="formData.profissao"
                                placeholder="Profissão"
                            />
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-6">
                            <label>Telefone Fixo</label>
                            <the-mask
                                type="text"
                                v-model="formData.tel_fixo"
                                placeholder="Telefone Fixo"
                                :mask="['(##) ####-####']"
                            />
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <label>Telefone Celular</label>
                            <the-mask
                                type="text"
                                v-model="formData.tel_celular"
                                placeholder="Telefone Celular"
                                :mask="['(##) #####-####']"
                            />
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-6">
                            <label>RG</label>
                            <input
                                type="text"
                                v-model="formData.RG"
                                placeholder="RG"
                            />
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <label>Orgão Emissor</label>
                            <input
                                type="text"
                                v-model="formData.orgao_emissor"
                                placeholder="Orgão Emissor"
                            />
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-6">
                            <label>Data Emissão</label>
                            <input
                                type="date"
                                v-model="formData.data_emissao"
                                placeholder="Data Emissão"
                            />
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <label>Data Nascimento</label>
                            <input
                                type="date"
                                v-model="formData.data_nascimento"
                                placeholder="Data Nascimento"
                            />
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-6">
                            <label>Estado Civil</label>
                            <select
                                class="browser-default"
                                v-model="formData.estado_civil"
                            >
                                <option value="" disabled selected>Selecione o estado civil</option>
                                <option value="Solteiro">Solteiro</option>
                                <option value="Casado">Casado</option>
                                <option value="Divorciado">Divorciado</option>
                                <option value="Viúvo">Viúvo</option>
                            </select>
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <label>Sexo</label>
                            <select
                                class="browser-default"
                                v-model="formData.sexo"
                            >
                                <option value="" disabled selected>Selecione o sexo</option>
                                <option value="Feminino">Masculino</option>
                                <option value="Masculino">Feminino</option>
                            </select>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-6">
                            <label>Pai</label>
                            <input
                                type="text"
                                v-model="formData.pai"
                                placeholder="Pai"
                            />
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <label>Mãe</label>
                            <input
                                type="text"
                                v-model="formData.mae"
                                placeholder="Mãe"
                            />
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-6">
                            <label>Representante Legal</label>
                            <select
                                class="browser-default"
                                v-model="formData.representante_legal"
                            >
                                <option value="" disabled selected>Selecione</option>
                                <option value="Sim">Sim</option>
                                <option value="Não">Não</option>
                            </select>
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <label>Assinatura Conjunta</label>
                            <select
                                class="browser-default"
                                v-model="formData.assinatura_conjunta"
                            >
                                <option value="" disabled selected>Selecione</option>
                                <option value="Sim">Sim</option>
                                <option value="Não">Não</option>
                            </select>
                        </div>
                    </div>
                </vsa-content>
            </vsa-item>

            <vsa-item>
                <vsa-heading>
                    Responsável Técnico
                </vsa-heading>

                <vsa-icon>
                    <vsa-custom-icon />
                </vsa-icon>

                <vsa-content>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-3">
                            <label>Responsável Técnico</label>
                            <input
                                type="text"
                                v-model="formData.responsavel_tecnico"
                                placeholder="Responsável Técnico"
                            />
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <label>CPF do Responsável Técnico</label>
                            <the-mask
                                type="text"
                                v-model="formData.resp_tecnico_cpf"
                                placeholder="CPF do Responsável Técnico"
                                :mask="['###.###.###-##']"
                            />
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <label>Susep PF</label>
                            <input
                                type="text"
                                v-model="formData.resp_tecnico_susep"
                                placeholder="Susep PF"
                            />
                        </div>
                    </div>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-3">
                            <label>Telefone Fixo</label>
                            <the-mask
                                type="text"
                                v-model="formData.resp_tecnico_tel_fixo"
                                placeholder="Telefone Fixo"
                                :mask="['(##) ####-####']"
                            />
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <label>Telefone Celular</label>
                            <the-mask
                                type="text"
                                v-model="formData.resp_tecnico_tel_celular"
                                placeholder="Telefone Celular"
                                :mask="['(##) #####-####']"
                            />
                        </div>
                    </div>
                </vsa-content>
            </vsa-item>
            <vsa-item>
                <vsa-heading>
                    Outros Dados
                </vsa-heading>

                <vsa-icon>
                    <vsa-custom-icon />
                </vsa-icon>

                <vsa-content>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-6">
                            <label>Email 2</label>
                            <input
                                type="text"
                                v-model="formData.email2"
                                placeholder="Email 2"
                            />
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <label>Email 3</label>
                            <input
                                type="text"
                                v-model="formData.email3"
                                placeholder="Email 3"
                            />
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <label>Email 4</label>
                            <input
                                type="text"
                                v-model="formData.email4"
                                placeholder="Email 4"
                            />
                        </div>

                        <!-- <div class="col-xs-12 col-md-4">
                            <label>URL Atualização Cad</label>
                            <input type="text" v-model="formData.url_atualizacao_cadastral" placeholder="URL Atualização Cad">
                        </div> -->

                        <!-- <div class="col-xs-12 col-md-4">
                            <label>Código Susep</label>
                            <input type="text" v-model="formData.cod_susep" placeholder="Código Susep">
                        </div> -->
                    </div>
                </vsa-content>
            </vsa-item>
            <vsa-item :key="formData.codigo_banco" v-if="banks.length != 0">
                <vsa-heading>
                    Bancários
                </vsa-heading>

                <vsa-icon>
                    <vsa-custom-icon />
                </vsa-icon>

                <vsa-content >
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-2">
                            <label>Agência</label>
                            <input
                                type="text"
                                v-model="formData.agencia"
                                placeholder="Agência"
                            />
                        </div>
                        <div class="col-xs-12 col-md-2">
                            <label>Conta</label>
                            <input
                                type="text"
                                v-model="formData.conta"
                                placeholder="Conta"
                            />
                        </div>
                        <div class="col-xs-12 col-md-2">
                            <label>Digito</label>
                            <input
                                type="text"
                                v-model="formData.digito"
                                placeholder="Digito"
                            />
                        </div>
                        <div class="col-xs-12 col-md-2">
                            <label>Código</label>
                            <input
                                type="text"
                                v-model="formData.codigo_banco"
                                placeholder="Banco"
                            />
                        </div>
                        <div class="col-xs-12 col-md-2">
                            <label>Banco</label>

                            <select
                                id="status_corretor"
                                class="browser-default"
                                v-model="formData.banco"
                                @change="funcSelectedBank(formData.banco)"
                            >
                                <option value="" disabled selected>Selecione um banco</option>
                                <option v-for="bank in banks" :value="bank.titulo">{{ bank.titulo }}</option>
                            </select>
                        </div>
                    </div>
                </vsa-content>
            </vsa-item>
        </vsa-list>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import Auth from "@/store/auth";
import {
    DONO,
    GERENTE,
    ESPECIALISTA,
    MASTER,
    PARCEIRO
} from "@/constants/funcionarioCargo.js";
import getPalavra from "@/helpers/language";
import { get, api_ff } from "@/helpers/api";
import {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon
} from "vue-simple-accordion";
import "vue-simple-accordion/dist/vue-simple-accordion.css";
import VsaCustomIcon from "@/components/common/VsaCustomIcon.vue";
import { TheMask } from "vue-the-mask"

export default {
    components: {
        Multiselect,
        VsaList,
        VsaItem,
        VsaHeading,
        VsaContent,
        VsaIcon,
        VsaCustomIcon,
        TheMask,
    },
    props: ["empresa"],
    data: () => ({
        lang: {
            corretora: getPalavra("corretora", false),
            parceira: getPalavra("parceira", false)
        },
        corretoras: [],
        formData: { ...this.empresa },
        titulo: "",
        paramsId: null,
        value: 3371,
        company: [],
        seguradorasExibirCodigo2345: ["Mapfre Vida"],
        seguradorasExibirNivel: [
            "Mapfre Vida",
            "Mapfre Consórcio",
            "Icatu",
            "IHB",
            "MAG",
            "Zurich",
            "Unimed",
            "Porto",
            "Vumi"
        ],
        seguradorasExibirSuperior: [
            "Icatu",
            "IHB",
            "MAG",
            "Zurich",
            "Unimed",
            "Porto"
        ],
        seguradoraExibirLoginSenha: ["Icatu"],
        seguradoraExibirCPF: ["Prudential"],
        seguradoraExibirSusep: ["Susep"],
        seguradoraExibirPrevidencia: ["Mapfre Vida", "Fiduc"],
        seguradorasExibirFiduc: ["Fiduc"],
        seguradorasExibirZurich: ["Zurich"],
        seguradorasExibirUnimed: ["Unimed"],
        seguradorasExibirPrudential: ["Prudential"],
        todasSeguradoras: [],
        banks: [],
    }),
    computed: {
        opcoesSeguradoras() {
            if (!this.todasSeguradoras) return [];
            return this.todasSeguradoras.map(seguradora => ({
                ...seguradora,
                ...(this.formData.seguradoras.find(
                    s => s.nome === seguradora.nome
                ) || {})
            }));
        },
    },
    created: async function() {
        // verifica se pode acessar componente
        if (
            Auth.getCargoUsuario() !== MASTER &&
            [DONO, GERENTE, ESPECIALISTA, PARCEIRO].indexOf(
                Auth.getCargoUsuario()
            ) === -1
        ) {
            //                this.$router.push('/sempermissao');
        }

        // api.get("empresa?page=0").then(response => {
        // this.corretoras = empresas.filter(e => e.empresa_tipo_id == 1);
        // });

        this.formData = { ...this.empresa };

        if (this.empresa.parent) {
            this.company.push(this.empresa.parent);
        }
        await this.getEmpresas();
        await this.getSeguradoras();
        this.getBanks();
        this.funcSelectedBank(this.empresa.banco);
    },
    watch: {
        formData: {
            handler() {
                this.$emit("input", this.formData);
                this.$emit("update:empresa", this.formData);
            },
            deep: true
        },
    },
    methods: {
        onSearchChange(query) {
            this.getEmpresas(query);
        },
        checkValue(value) {
            if (value !== "") {
                return "active";
            }
            return "";
        },
        checkEmpresaTipo() {
            if (this.formData.empresa_tipo_id === 1) {
                this.formData.empresa_tipo_id = 1;
            } else {
                this.formData.empresa_tipo_id = 2;
            }
        },
        async getEmpresas(search = "") {
            await get("empresa", { params: { search } }).then(response => {
                const data = response.data.result.data.data;
                this.company = data;
            });
        },
        async getSeguradoras() {
            await get("seguradora").then(response => {
                const data = response.data.result.data;
                this.todasSeguradoras = data;
            });
        },
        onChange: function(event) {
            this.formData.parent_id = event.empresa_id;
        },
        async getBanks() {
            api_ff.get("/bancos").then(response => {
                const data = response.data.data;
                this.banks = data;
            });
        },
        funcSelectedBank(name){
            api_ff.get("/banco/" + name).then(response => {
                const {codigo_banco} = response.data
                console.log('aqui no banco', codigo_banco);
                this.formData.codigo_banco = codigo_banco;
            });
        },
    },

    mounted: async function() {
        this.checkEmpresaTipo();
    }
};
/* setTimeout(function(){
        console.log('passou 10 segundos...');

        $(document).ready(function() {

            function limpa_formulário_cep() {
                // Limpa valores do formulário de cep.
                $("#endereco").val("");
                $("#bairro").val("");
                $("#cidade").val("");
                $("#estado").val("");
                $("#ibge").val("");
            }

            //Quando o campo cep perde o foco.
            $("#cep").blur(function() {
                console.log('chamou o blur');
                //Nova variável "cep" somente com dígitos.
                var cep = $(this).val().replace(/\D/g, '');

                //Verifica se campo cep possui valor informado.
                if (cep != "") {

                    //Expressão regular para validar o CEP.
                    var validacep = /^[0-9]{8}$/;

                    //Valida o formato do CEP.
                    if(validacep.test(cep)) {

                        //Preenche os campos com "..." enquanto consulta webservice.
                        $("#endereco").val("...");
                        $("#bairro").val("...");
                        $("#cidade").val("...");
                        $("#estado").val("...");
                        $("#ibge").val("...");

                        //Consulta o webservice viacep.com.br/
                        $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {

                            if (!("erro" in dados)) {
                                //Atualiza os campos com os valores da consulta.
                                $("#endereco").val(dados.logradouro);
                                $("#bairro").val(dados.bairro);
                                $("#cidade").val(dados.localidade);
                                $("#estado").val(dados.uf);
                                $("#ibge").val(dados.ibge);
                            } //end if.
                            else {
                                //CEP pesquisado não foi encontrado.
                                limpa_formulário_cep();
                                alert("CEP não encontrado.");
                            }
                        });
                    } //end if.
                    else {
                        //cep é inválido.
                        limpa_formulário_cep();
                        alert("Formato de CEP inválido.");
                    }
                } //end if.
                else {
                    //cep sem valor, limpa formulário.
                    limpa_formulário_cep();
                }
            });
        });
    },10000)*/
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
#alerta-indicacao {
    background-color: #efefef;
    padding: 10px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin-bottom: 25px;
}
.vsa-list {
    max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/Formulario.vue